import { IItemForGetShortInfo } from 'types';
import React from 'react';
import ComboItemsMultipleSelect from './components/ComboItemsMultipleSelect';
import DnDList from './components/DnDList';
import style from './ComboItemsField.module.scss';

interface IComboItemsField {
	setComboItems: (value: string[]) => void;
	setFetchedComboItems: (value: IItemForGetShortInfo[]) => void;
	updateComboItems: (value: IItemForGetShortInfo[]) => void;
	selectedRestaurants: string[];
	selectedComboItems: string[];
	fetchedComboItems: IItemForGetShortInfo[];
}

const ComboItemsField: React.FC<IComboItemsField> = ({
	selectedComboItems,
	selectedRestaurants,
	fetchedComboItems,
	setFetchedComboItems,
	setComboItems,
	updateComboItems,
}) => {
	return (
		<div className={style.container} data-test="ComboItemsField">
			<div className={style.field}>
				<ComboItemsMultipleSelect
					selectedComboItems={selectedComboItems}
					selectedRestaurants={selectedRestaurants}
					setComboItems={setComboItems}
					setFetchedComboItems={setFetchedComboItems}
					updateComboItems={updateComboItems}
				/>
			</div>
			<DnDList
				selectedComboItems={selectedComboItems}
				setComboItems={setComboItems}
				fetchedComboItems={fetchedComboItems}
			/>
		</div>
	);
};

export default React.memo(ComboItemsField);
